/* eslint-ignore */
// @ts-nocheck
import React from 'react';
import Navbar from '~/components/layout/NavbarNew';
import UserMenu from '~/components/layout/UserMenu';
import {
  Container,
  Hr,
  Tip,
  TipContainer,
  Title,
  UserResponsive,
} from './styles';

const dicasSeguranca = () => (
  <Navbar selected="PerguntasFrequentes">
    <UserResponsive>
      <UserMenu breadcrump="› Dicas de Segurança" mobile />
    </UserResponsive>
    <Container>
      <Title>Dicas de segurança</Title>
      <Hr />
      <TipContainer>
        <Tip>
          01. Disponibilize o número correto de extintores prontos para uso de
          acordo com a sua classe de incêndio. Eles sempre devem estar dentro do
          prazo de validade e desobstruídos;
        </Tip>
      </TipContainer>
      <TipContainer>
        <Tip>
          02. Não instale novos aparelhos eletrônicos e máquinas elétricas
          próximas às instalações de GLP sem a consulta prévia da empresa;
        </Tip>
      </TipContainer>
      <TipContainer>
        <Tip>
          03. Conte com a assistência dos profissionais qualificados da Ultragaz
          para instalar qualquer tipo de botijão ou cilindro;
        </Tip>
      </TipContainer>
      <TipContainer>
        <Tip>
          04. Não realize modificações ou qualquer tipo de obra na central de
          gás sem comunicar ou receber orientação da equipe da Ultragaz;
        </Tip>
      </TipContainer>
      <TipContainer>
        <Tip>
          05. Sempre mantenha a central de GLP limpa e desobstruída de quaisquer
          materiais;
        </Tip>
      </TipContainer>
      <TipContainer>
        <Tip>
          06. Não permita que ninguém mexa ou opere o tanque. As únicas pessoas
          autorizadas são os funcionários da Ultragaz;
        </Tip>
      </TipContainer>
      <TipContainer>
        <Tip>
          07. Em caso de emergência, chame o Corpo de Bombeiros, a Assistência
          Técnica da Ultragaz e isole a área. Não permita o acesso de outras
          pessoas e curiosos e isole qualquer fonte de ignição.
        </Tip>
      </TipContainer>
    </Container>
  </Navbar>
);

export default dicasSeguranca;
